import './style.scss'
import Layer from '../../../Shared/Layer'
import { Trans } from 'react-i18next'
import { Col, Container, Row } from '@trendmicro/react-grid-system'
import { useDispatch, useSelector } from 'react-redux'
import { factsheetActions } from '../../../../redux/actions/factsheet'
import { findFactComponentById } from '../helper'
import { useCallback, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_FACTSHEET_BLUEPRINT } from '../shapes'
import ComponentLoader from '../components/component-loader'
import { FACT_ATTRIBUTE_IDS, FACT_IDS } from '../constants'

const CurrencySelectorOverlay = ({ onDone, blueprint }) => {
  const dispatch = useDispatch()
  const deleteFact = useCallback((...args) => dispatch(factsheetActions.deleteFact(...args)), [dispatch])
  const currencyFactComponent = useMemo(() => findFactComponentById(blueprint, FACT_IDS.CURRENCY), [blueprint])
  const currencyComponent = currencyFactComponent.components[0]
  const afterDeleteAttribute = useCallback(() => {
    deleteFact(currencyFactComponent.id)
  }, [currencyFactComponent.id, deleteFact])
  const currencyCodeValue = useSelector(state => {
    if (!state.factsheet.facts[FACT_IDS.CURRENCY]) {
      return null
    }
    return state.factsheet.facts[FACT_IDS.CURRENCY][0]?.attributes[FACT_ATTRIBUTE_IDS.CURRENCY_CODE]?.value
  })

  useEffect(() => {
    if (currencyCodeValue) {
      onDone()
    }
  }, [currencyCodeValue, onDone])

  return (
    <Layer
      type="center"
      size="small"
      id={'currency-selector'}
      show={true}
      onHideClick={onDone}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="currency-selector-overlay"
      closeOnEsc={true}
      disallowHiding={false}
    >
      <Container fluid>
        <Row>
          <Col xs={3}>
            <span className="currency-selector-overlay__currencies_icon"></span>
          </Col>
          <Col xs={9}>
            <span className="currency-selector-overlay__text">
              <Trans i18nKey="editProperty.factsheet.currencySelector.header"/>
            </span>
          </Col>
        </Row>
        <Row>
          <br/>
        </Row>
        <Row>
          <Col xs={3}></Col>
          <Col xs={9}>
            <ComponentLoader
              blueprint={currencyComponent}
              parentBlueprint={currencyFactComponent}
              factsheetBlueprint={blueprint}
              factInstanceKey={0}
              collapsed={false}
              afterDeleteAttribute={afterDeleteAttribute}
            />
          </Col>
        </Row>
      </Container>
    </Layer>
  )
}

CurrencySelectorOverlay.propTypes = {
  blueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  onDone: PropTypes.func.isRequired,
}

export default CurrencySelectorOverlay
